module.exports = __webpack_public_path__ + "static/img/vip.fdc9a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip.jpg
// module id = hK0q
// module chunks = 0